import moment from 'moment'

const maskDogumTarihi = (value) => {
    return value ? moment(value, 'YYYY-MM-DDT00:00:00').format('DD/MM/YYYY') : null
}

export default maskDogumTarihi